/* eslint-disable camelcase */
import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/api/vacations/list', { ...params, cancelDuplicates: true });
  },
  createData() {
    return Backend.get('/api/vacations/create');
  },
  editData(id) {
    return Backend.get(`/api/vacations/${id}/edit`);
  },
  create(data) {
    return Backend.post('/api/vacations/', data);
  },
  update(data) {
    return Backend.put(`/api/vacations/${data.id}`, data);
  },
  formData() {
    return Backend.get('/api/vacations/form-data');
  },
  changeStatus(data) {
    return Backend.put(`/api/vacations/${data.id}/status-change`, data);
  },
};
